(function () {
  var COLUMN_COUNT = 3;

  // Tous les codes ci-dessous sont regroupés sous une seule colonne "DOM-TOM"
  // au lieu d'un groupe séparé par territoire. Ajoutez-en si besoin (Saint-Pierre-
  // et-Miquelon PM, Terres australes TF, Wallis-et-Futuna WF ne sont pas dans les
  // données actuelles mais sont inclus par anticipation).
  var DOM_TOM_CODES = ['RE', 'GP', 'MQ', 'GF', 'YT', 'NC', 'PF', 'BL', 'MF', 'PM', 'WF', 'TF'];

  // Ajoutez ici d'autres pays si votre API en renvoie (BE, ES, LU, CH...).
  var COUNTRY_LABELS = {
    FR: 'France métropolitaine',
    DOMTOM: 'DOM-TOM',
    BE: 'Belgique',
    ES: 'Espagne',
    LU: 'Luxembourg',
    CH: 'Suisse',
    DE: 'Allemagne',
    IT: 'Italie',
    MA: 'Maroc',
    PT: 'Portugal',
    GB: 'Royaume-Uni',
    US: 'États-Unis',
    CA: 'Canada'
  };

  function groupKey(countryCode) {
    if (DOM_TOM_CODES.indexOf(countryCode) !== -1) return 'DOMTOM';
    return countryCode || 'Autre';
  }

  function escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function slugify(str) {
    return (str || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function departmentCode(zip) {
    var z = (zip || '').replace(/\D/g, '');
    if (!z) return '';
    if (z.length >= 3 && (z.slice(0, 2) === '97' || z.slice(0, 2) === '98')) return z.slice(0, 3);
    return z.slice(0, 2);
  }

  function initStoresList(root) {
    // L'ID de section (ex. "template--12345__stores_list") est déduit de l'ID du
    // conteneur lui-même ("StoresList-<id>"), puisqu'on n'a plus {{ section.id }}
    // ici — ce fichier est un asset statique, pas traité par Liquid.
    var sectionId = root.id.indexOf('StoresList-') === 0 ? root.id.slice('StoresList-'.length) : '';

    var apiUrl = root.dataset.apiUrl;
    var baseUrl = (root.dataset.baseUrl || '/pages/').replace(/\/?$/, '/');
    var openNewTab = root.dataset.openNewTab === 'true';
    var namePrefixStrip = root.dataset.namePrefixStrip || '';
    var slugOverrides = {};
    try { slugOverrides = JSON.parse(root.dataset.slugOverrides || '{}'); } catch (e) { slugOverrides = {}; }

    var groupsEl = root.querySelector('.stores-list__groups');
    var entryTemplate = document.getElementById('store-list-entry-template-' + sectionId);
    var countryTemplate = document.getElementById('store-list-country-template-' + sectionId);
    var columnTemplate = document.getElementById('store-list-column-template-' + sectionId);

    if (!groupsEl || !entryTemplate || !countryTemplate || !columnTemplate) {
      console.error('Stores list: templates introuvables pour', root.id);
      return;
    }

    function storeUrl(store) {
      var slug = slugOverrides[store.code] || slugify(store.name);
      return baseUrl + slug;
    }

    function displayLabel(name) {
      if (!namePrefixStrip) return name;
      var re = new RegExp('^' + escapeRegExp(namePrefixStrip) + '\\s*', 'i');
      var stripped = name.replace(re, '').trim();
      return stripped || name;
    }

    function buildEntry(store) {
      var node = entryTemplate.content.cloneNode(true);
      var a = node.querySelector('a');
      a.setAttribute('href', store.url);
      a.setAttribute('title', store.name);
      if (openNewTab) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      }
      a.querySelector('.postal-code').textContent = store.dept;
      a.querySelector('.location-title').textContent = store.label;
      return node;
    }

    function buildColumn(items) {
      var node = columnTemplate.content.cloneNode(true);
      var p = node.querySelector('.stores-list__entries');
      items.forEach(function (store, index) {
        p.appendChild(buildEntry(store));
        if (index < items.length - 1) p.appendChild(document.createElement('br'));
      });
      return node;
    }

    function buildCountryGroup(key, items) {
      var node = countryTemplate.content.cloneNode(true);
      node.querySelector('.stores-list__country-title').textContent =
        COUNTRY_LABELS[key] || (items[0] && items[0].countryLabel) || key;
      var ul = node.querySelector('.stores-list__columns');

      var chunkSize = Math.ceil(items.length / COLUMN_COUNT);
      for (var c = 0; c < COLUMN_COUNT; c++) {
        var chunk = items.slice(c * chunkSize, (c + 1) * chunkSize);
        if (!chunk.length) continue;
        ul.appendChild(buildColumn(chunk));
      }
      return node;
    }

    function buildGroups(stores) {
      var byCountry = {};
      stores.forEach(function (store) {
        var key = groupKey(store.country);
        if (!byCountry[key]) byCountry[key] = [];
        byCountry[key].push(store);
      });

      // Ordre : France, puis DOM-TOM, puis les autres pays par ordre alphabétique de libellé.
      var countryKeys = Object.keys(byCountry).sort(function (a, b) {
        var priority = { FR: 0, DOMTOM: 1 };
        var pa = priority.hasOwnProperty(a) ? priority[a] : 2;
        var pb = priority.hasOwnProperty(b) ? priority[b] : 2;
        if (pa !== pb) return pa - pb;
        if (pa !== 2) return 0;
        var labelA = COUNTRY_LABELS[a] || a;
        var labelB = COUNTRY_LABELS[b] || b;
        return labelA.localeCompare(labelB);
      });

      groupsEl.innerHTML = '';

      countryKeys.forEach(function (key) {
        var items = byCountry[key].slice().sort(function (a, b) {
          return a.dept.localeCompare(b.dept) || a.label.localeCompare(b.label);
        });
        groupsEl.appendChild(buildCountryGroup(key, items));
      });
    }

    function fetchStores() {
      return fetch(apiUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var raw = Array.isArray(data) ? data : (data.locations || data.stores || data.results || data.data || []);
          var stores = raw.map(function (item) {
            var addr = item.address || {};
            var details = item.details || {};
            var name = details.name || item.code;
            return {
              code: item.code,
              name: name,
              label: displayLabel(name),
              zip: addr.zip || '',
              dept: departmentCode(addr.zip),
              country: addr.country_code || '',
              countryLabel: addr.country_label || '',
              url: ''
            };
          });
          stores.forEach(function (store) { store.url = storeUrl(store); });
          buildGroups(stores);
        })
        .catch(function (err) {
          console.error('Store list: erreur de chargement des magasins', err);
          groupsEl.innerHTML = '<p class="store-list__error">Impossible de charger la liste des magasins pour le moment. Merci de réessayer plus tard.</p>';
        });
    }

    fetchStores();
  }

  document.querySelectorAll('.stores-list').forEach(initStoresList);
})();